import { Box, Grid, TablePagination, Typography } from "@mui/material";
import { useState } from "react";
import { useQuery } from "react-query";
import { getAllResources } from "../../../api/services/api";
import EmptyScreen from "../../../components/EmptyScreen";
import Loader from "../../../components/Loader";
import ResourcesCard from "../../../components/ResourcesCard";

const Videos = () => {
  const [limit, setLimit] = useState<number>(10);
  const [page, setPage] = useState<number>(0);

  const { data, isLoading } = useQuery(
    [
      "videos",
      {
        type: "VIDEO",
        limit: limit,
        offset: limit * page,
      },
    ],
    getAllResources
  );

  const handlePageChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event: any) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div>
      {" "}
      <Box
        sx={{
          marginBottom: "20px",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }} gap={"26px"}>
          <Typography variant="h4">Videos</Typography>
        </Box>
      </Box>
      {data?.data?.count === 0 ? (
        <EmptyScreen type={"videos"} />
      ) : (
        <>
          <Grid container spacing={7}>
            {data?.data?.resources?.map((item: any, index: number) => {
              return (
                <Grid item xs={4} key={index}>
                  <ResourcesCard
                    data={item}
                    video={item?.link}
                    thumbnail={item?.thumbnail}
                    date={item?.createdAt}
                    title={item?.title}
                    desc={item?.description}
                  />
                </Grid>
              );
            })}
          </Grid>
          <Box
            sx={{
              marginTop: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <TablePagination
              count={data?.data.count}
              page={page}
              onPageChange={handlePageChange}
              rowsPerPage={limit}
              onRowsPerPageChange={handleRowsPerPageChange}
            />
          </Box>
        </>
      )}
    </div>
  );
};

export default Videos;
